import type { Directive } from "vue";
import DOMPurify from "dompurify";

// Sanea HTML proveniente de API/CMS/usuario antes de inyectarlo en el DOM.
// Sustituto seguro de `v-html`: elimina <script>, manejadores on*, javascript:, etc.
// evitando XSS almacenado (testimonios, blog, legales, errores, cuerpos de email...).
const sanitize = (value: unknown): string =>
  DOMPurify.sanitize(value == null ? "" : String(value));

const safeHtml: Directive<HTMLElement, unknown> = {
  beforeMount(el, binding) {
    el.innerHTML = sanitize(binding.value);
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = sanitize(binding.value);
    }
  },
};

export default safeHtml;
